import sortBy from 'lodash/sortBy'

export default {
  setClientDetails: (state, clientDetails) => {
    state.clientDetails = sortBy(Object.keys(clientDetails).map(key => { const el = clientDetails[key]; el.clientName = key; return el }), 'clientNameDesc')
    state.clientIndex = {}
    state.clientDetails.forEach(v => state.clientIndex[v.id] = v)
  },
  setClientDatabaseDetails: (state, clientDatabaseDetails) => {
    state.clientDatabaseDetails = clientDatabaseDetails
    state.clientDatabaseList = Object.keys(clientDatabaseDetails).map(key => { const el = clientDatabaseDetails[key]; el.databaseId = parseInt(key); return el })
  }
}
